var _path, _g, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAiIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_526_7)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_526_7",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 107,
    height: 107
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107 0H0V107H107V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_526_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.5 107C83.0473 107 107 83.0473 107 53.5C107 23.9527 83.0473 0 53.5 0C23.9527 0 0 23.9527 0 53.5C0 83.0473 23.9527 107 53.5 107Z",
    fill: "#D2951B"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2 35H49.05C50.25 35 51 35.55 51.3 36.65L62.45 68.55C62.4833 68.65 62.5 68.8167 62.5 69.05C62.5 69.25 62.3833 69.4667 62.15 69.7C61.95 69.9 61.7 70 61.4 70H52.15C51.15 70 50.5 69.5833 50.2 68.75L49 65.45H38.25L37.05 68.75C36.75 69.5833 36.1 70 35.1 70H25.85C25.55 70 25.2833 69.9 25.05 69.7C24.85 69.4667 24.75 69.25 24.75 69.05C24.75 68.8167 24.7667 68.65 24.8 68.55L35.95 36.65C36.25 35.55 37 35 38.2 35ZM40.8 55.7H46.45L43.6 46.4L40.8 55.7ZM78.0578 70H67.8578C67.4911 70 67.1745 69.8667 66.9078 69.6C66.6411 69.3333 66.5078 69.0167 66.5078 68.65V36.35C66.5078 35.9833 66.6411 35.6667 66.9078 35.4C67.1745 35.1333 67.4911 35 67.8578 35H78.0578C78.4245 35 78.7411 35.1333 79.0078 35.4C79.2745 35.6667 79.4078 35.9833 79.4078 36.35V68.65C79.4078 69.0167 79.2745 69.3333 79.0078 69.6C78.7411 69.8667 78.4245 70 78.0578 70Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_526_7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 107,
    height: 107,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIcon);
export default __webpack_public_path__ + "static/media/AI-icon.532e9075ceb4b5e8b2e4c99658f28417.svg";
export { ForwardRef as ReactComponent };